import type { CanActivateFn } from '@angular/router';

export const isOnlineGuard: CanActivateFn = (route, state) => {
  return !window.navigator.onLine;
};
